import { InjectionToken } from '@angular/core';

// Stockage persistant du navigateur, null s'il est indisponible (navigation
// privee, cookies bloques). Injectable pour etre remplace dans les tests.
export const BROWSER_STORAGE = new InjectionToken<Storage | null>('BROWSER_STORAGE', {
  providedIn: 'root',
  factory: () => {
    try {
      return window.localStorage ?? null;
    } catch {
      return null;
    }
  },
});
